/**
 * Shared `List` marker presets for the onboarding flow.
 *
 * Kept out of `List.tsx` so that file keeps exporting only components and types
 * (`react-refresh/only-export-components`).
 */

import { colors } from '../../../../styles/colors';
import { radii } from '../../../../styles/onboardingUiTokens';
import type { ListIconPreset } from './List';

/**
 * Benefit/feature check marker: white tick in a round brand-blue well.
 *
 * Spread onto a `List` together with `iconBoxed`:
 * `<List {...checkMarker} iconBoxed …>`.
 *
 * The round shape is load-bearing, the colour is not: a *square* filled tick reads as one of the
 * real consent checkboxes, which are light, square and bordered (the ERS-61 objection that first
 * moved these markers away from a filled tick). Change the fill freely; change the shape only
 * deliberately.
 *
 * The well is `1.5em` — em, so it tracks the body text it sits beside rather than the root size —
 * around a tick that stays 20 px. At the 15 px body that is a 22.5 px well hugging the mark.
 *
 * No `columnGap` here on purpose: `List`'s own `space.sm` default is the gap this size wants.
 */
export const checkMarker: {
  icon: ListIconPreset;
  iconBoxBackground: string;
  iconBoxRadius: string;
  iconBoxSize: string;
} = {
  icon: { name: 'check', size: 20, primaryColor: colors.white },
  iconBoxBackground: colors.primary,
  iconBoxRadius: radii.pill,
  iconBoxSize: '1.5em',
};
